<template>
  <b-modal
    ref="mdlExportarCsv"
    id="mdlExportarCsv"
    hide-header
    hide-footer
    centered
    size="md"
    dialog-class="modal-exportar-csv-dialog"
    body-class="p-0"
    ignore-enforce-focus-selector=".swal2-container"
    @shown="onModalShown"
    @hidden="onModalHidden"
  >
    <!-- Modal Content wrapper -->
    <div class="modal-exportar-container">
      <!-- Top header / filter selection -->
      <div class="modal-exportar-header p-4 border-bottom">
        <h5 class="font-weight-bold mb-3">Exportar Agendamentos</h5>
        <div class="form-group mb-0">
          <label class="font-weight-bold text-muted small uppercase"
            >Filtrar por</label
          >
          <select
            v-model="filtrarPor"
            class="form-control custom-select-filter"
          >
            <option value="data_agendamento">Data de Agendamento</option>
            <option value="data_cadastro">Data de Cadastro</option>
          </select>
        </div>
      </div>

      <!-- Main Body: 2 Columns Date Picker -->
      <div class="datepicker-layout d-flex">
        <!-- Left Column: Shortcuts -->
        <div class="shortcuts-column py-3 px-2">
          <button
            v-for="shortcut in shortcuts"
            :key="shortcut.key"
            type="button"
            class="shortcut-btn text-left btn btn-block btn-clean py-2 px-3"
            :class="{ active: activeShortcut === shortcut.key }"
            @click="selectShortcut(shortcut.key)"
          >
            {{ shortcut.label }}
          </button>
        </div>

        <!-- Right Column: PrimeVue Calendar -->
        <div
          class="calendar-column p-3 flex-1 d-flex justify-content-center align-items-center"
        >
          <Calendar
            v-if="modalAberto"
            @input="onCalendarChange"
            v-model="datasSelecionadas"
            selection-mode="range"
            :inline="true"
          />
        </div>
      </div>

      <!-- Footer Actions -->
      <div
        class="modal-exportar-footer d-flex justify-content-end align-items-center p-3 border-top bg-light"
      >
        <button
          type="button"
          class="btn btn-link mr-4 font-weight-bold btn-cancel"
          @click="fechar"
        >
          Cancelar
        </button>
        <b-button
          type="button"
          class="btn btn-select px-4 py-2 font-weight-bold"
          :disabled="!hasSelection"
          @click="confirmarExportacao"
        >
          Selecionar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import download from "downloadjs";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import Calendar from "primevue/calendar";

export default {
  name: "ModalExportarCsv",
  components: {
    Calendar
  },
  data() {
    return {
      filtrarPor: "data_agendamento",
      datasSelecionadas: null,
      activeShortcut: "hoje",
      modalAberto: false,
      calendarRange: null,
      shortcuts: [
        { key: "personalizado", label: "Personalizado" },
        { key: "hoje", label: "Hoje" },
        { key: "ontem", label: "Ontem" },
        { key: "esta_semana", label: "Esta semana" },
        { key: "este_mes", label: "Este mês" },
        { key: "mes_anterior", label: "Mês anterior" },
        { key: "prox_mes", label: "Próximo mês" }
      ]
    };
  },
  computed: {
    hasSelection() {
      return (
        this.datasSelecionadas &&
        this.datasSelecionadas.length > 0 &&
        this.datasSelecionadas[0] !== null
      );
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    abrir(range, porDataCadastro) {
      this.filtrarPor = porDataCadastro ? "data_cadastro" : "data_agendamento";
      this.calendarRange = range;
      if (range) {
        this.selectShortcut("personalizado");
      } else {
        this.selectShortcut("hoje");
      }
      this.$refs["mdlExportarCsv"].show();
    },
    fechar() {
      this.$refs["mdlExportarCsv"].hide();
    },
    onModalShown() {
      this.modalAberto = true;
      window.addEventListener("keydown", this.handleKeyDown);
    },
    onModalHidden() {
      this.modalAberto = false;
      window.removeEventListener("keydown", this.handleKeyDown);
    },
    handleKeyDown(event) {
      if (event.key === "Escape" || event.key === "Esc") {
        this.fechar();
      }
    },
    selectShortcut(shortcutKey) {
      this.activeShortcut = shortcutKey;
      let start, end;

      switch (shortcutKey) {
        case "personalizado":
          if (this.calendarRange) {
            start = moment(this.calendarRange.start);
            end = moment(this.calendarRange.end);
          } else {
            start = moment();
            end = moment();
          }
          break;
        case "hoje":
          start = moment();
          end = moment();
          break;
        case "ontem":
          start = moment().subtract(1, "day");
          end = moment().subtract(1, "day");
          break;
        case "esta_semana":
          start = moment().startOf("week");
          end = moment().endOf("week");
          break;
        case "este_mes":
          start = moment().startOf("month");
          end = moment().endOf("month");
          break;
        case "mes_anterior":
          start = moment().subtract(1, "month").startOf("month");
          end = moment().subtract(1, "month").endOf("month");
          break;
        case "prox_mes":
          start = moment().add(1, "month").startOf("month");
          end = moment().add(1, "month").endOf("month");
          break;
      }

      this.datasSelecionadas = [start.toDate(), end.toDate()];
    },
    onCalendarChange() {
      // Clear active shortcut when the user manually changes selection
      this.activeShortcut = null;
    },
    confirmarExportacao() {
      if (!this.hasSelection) return;

      const start = this.datasSelecionadas[0];
      const end = this.datasSelecionadas[1] || start;

      const dataInicio = moment(start).format("YYYY-MM-DD");
      const dataFim = moment(end).format("YYYY-MM-DD");

      const params = {
        data_inicio: dataInicio,
        data_fim: dataFim,
        filtrar_por: this.filtrarPor
      };

      ApiService.get("agenda/calendario/exportar", "", true, {
        params: params
      })
        .then((response) => {
          const eventos =
            (response.data &&
              response.data.data &&
              response.data.data.eventos) ||
            [];

          let headers = [];
          if (eventos.length > 0) {
            headers = Object.keys(eventos[0]);
          } else {
            headers = ["Nenhum registro encontrado"];
          }

          const csvRows = [];
          csvRows.push(headers.join(","));

          eventos.forEach((row) => {
            const values = headers.map((header) => {
              const val =
                row[header] !== undefined && row[header] !== null
                  ? row[header]
                  : "";
              const escaped = ("" + val).replace(/"/g, '""');
              return `"${escaped}"`;
            });
            csvRows.push(values.join(","));
          });

          const csvContent = "\ufeff" + csvRows.join("\n");
          const dateRangeStr =
            dataFim && dataFim !== dataInicio
              ? `${dataInicio}_a_${dataFim}`
              : `${dataInicio}`;

          download(
            new Blob([csvContent], { type: "text/csv;charset=utf-8;" }),
            `exportacao_agendamentos_${dateRangeStr}.csv`,
            "text/csv"
          );

          this.fechar();

          Swal.fire({
            title: "Sucesso!",
            text: "Dados exportados com sucesso.",
            icon: "success",
            confirmButtonText: "Ok",
            heightAuto: false
          });
        })
        .catch((error) => {
          console.error(error);
          Swal.fire({
            title: "Erro!",
            text: "Não foi possível realizar a exportação dos agendamentos.",
            icon: "error",
            confirmButtonText: "Ok",
            heightAuto: false
          });
        });
    }
  }
};
</script>

<style scoped>
.modal-exportar-csv-dialog {
  max-width: 520px;
}

.modal-exportar-container {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.custom-select-filter {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  font-size: 14px;
  background-color: #f9fafb;
}

.datepicker-layout {
  min-height: 290px;
}

/* Shortcuts styling */
.shortcuts-column {
  width: 150px;
  border-right: 1px solid #f3f4f6;
  background-color: #fafafa;
}

.shortcut-btn {
  font-size: 13px;
  color: #4b5563;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
}

.shortcut-btn:hover {
  background-color: #f3f4f6;
  color: #111827;
}

.shortcut-btn.active {
  background-color: rgba(71, 34, 130, 0.1);
  color: #472282;
  font-weight: bold;
}

/* Calendar styling */
.calendar-column {
  background-color: #fff;
}

.calendar-column ::v-deep .p-datepicker {
  width: auto !important;
  min-width: 280px;
}

.calendar-column ::v-deep .p-datepicker table td > span.p-highlight {
  background-color: #472282 !important;
  color: #ffffff !important;
}

/* Footer styling */
.btn-cancel {
  color: #472282;
  text-decoration: none;
  font-size: 14px;
}

.btn-cancel:hover {
  text-decoration: underline;
  color: #381b66;
}

.btn-select {
  background-color: #472282;
  color: white;
  border: none;
  font-size: 14px;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.btn-select:disabled {
  background-color: #cbd5e1;
  color: #94a3b8;
  cursor: not-allowed;
  box-shadow: none;
}
</style>
